import {
    BlockStack,
    Text,
    InlineStack,
    Button,
    DropZone,
} from "@shopify/ui-extensions-react/customer-account";
import { useTranslate } from "@shopify/ui-extensions-react/customer-account";
import { SlotUploadControlProps } from "../types";

export const SlotUploadControl = ({
    slot,
    file,
    progress,
    onFileSelect,
    onRemove,
    disabled,
}: SlotUploadControlProps) => {
    const translate = useTranslate();

    const handleDropZoneInput = (_files: File[]) => {
        const files = _files as File[];
        if (files.length > 0) {
            onFileSelect(files[0], slot.id);
        }
    };

    return (
        <BlockStack spacing="tight">
            <Text emphasis="bold">{slot.label}</Text>

            {file ? (
                <BlockStack spacing="base" padding="base" border="base" cornerRadius="base">
                    <InlineStack inlineAlignment="center" spacing="base">
                        <Text>{file.name}</Text>
                    </InlineStack>

                    {progress && progress.status === 'uploading' && (
                        <Text appearance="subdued">
                            {translate('slotUpload.uploading', { progress: Math.round(progress.progress) })}
                        </Text>
                    )}

                    {progress && progress.status === 'error' && (
                        <Text appearance="critical">
                            {translate('slotUpload.error', { message: progress.error || 'Unknown error' })}
                        </Text>
                    )}

                    {progress && progress.status === 'success' && (
                        <Text appearance="success">{translate('slotUpload.uploaded')}</Text>
                    )}

                    <Button
                        kind="plain"
                        onPress={() => onRemove(slot.id)}
                        disabled={disabled || (progress?.status === 'uploading')}
                    >
                        {translate('slotUpload.remove')}
                    </Button>
                </BlockStack>
            ) : (
                <DropZone
                    accept="image/jpeg,image/png,image/gif,image/webp"
                    multiple={false}
                    onInput={handleDropZoneInput}
                    disabled={disabled}
                    label={translate('slotUpload.uploadPhoto')}
                />
            )}
        </BlockStack>
    );
};
